<template>
  <!-- <DealerDialog></DealerDialog > -->
  <v-container fluid>
    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-dialog v-model="dialog" max-width="50vw" max-height="50vh">
        <v-card>
          <v-card-title>
            <v-title>Update ABN</v-title>
          </v-card-title>
          <v-card-text>
            <v-container fluid></v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="updateABN"
                :rules="abnRules"
                label="Update ABN"
                required
              ></v-text-field>
              <v-btn :disabled="!valid" class="primary" @click="submit">
                Submit
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--            <div>-->
      <!--                <v-layout row>-->
      <!--                    <v-flex xs4>-->
      <!--                        <v-text-field name="Search" label="Search" v-model="SearchText" append-icon="search"></v-text-field>-->
      <!--                    </v-flex>-->
      <!--                </v-layout>-->
      <!--            </div>-->

      <v-data-table
        xs12
        :total-items="totalItems"
        :pagination.sync="pagination"
        :items="items"
        :headers="headers"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <td
            v-for="(prop, propIndex) in headers.filter(
              (x) => x.text !== 'Actions'
            )"
            :key="propIndex"
            :class="'ma-0'"
          >
            <div v-if="prop.autocomplete" :class="'text-xs-' + prop.align">
              {{ props.item[prop.value][prop.nested] }}
            </div>

            <div
              v-else
              :class="
                'text-xs-' + prop.align + ' d-flex justify-content-center'
              "
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                {{ props.item[prop.value] }}
              </div>
              <div v-if="prop.value == 'abn'">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
              </div>
            </div>
          </td>
        </template>
      </v-data-table>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'failed-qantas-points',
  data: () => ({
    valid: true,
    SearchText: null,
    loading: false,
    items: [],
    editedItem: null,
    editedIndex: 0,
    totalItems: 0,
    dialog: false,
    updateABN: null,
    abnRules: [(v) => !!v || 'ABN is required'],
    headers: [
      {
        text: 'ID',
        align: 'right',
        sortable: true,
        value: 'id',
      },
      {
        text: 'Customer Number',
        align: 'right',
        sortable: true,
        value: 'custNo',
      },
      {
        text: 'ABN',
        align: 'right',
        sortable: true,
        value: 'abn',
      },
      {
        text: 'Bonus Points Paid',
        align: 'right',
        sortable: true,
        value: 'bonusPointsPaid',
      },
      {
        text: 'Points Paid',
        align: 'right',
        sortable: true,
        value: 'pointsPaid',
      },
      {
        text: 'File Set Number',
        value: 'fileSetNumber',
        sortable: true,
      },
      {
        text: 'Sequence Number',
        value: 'sequenceNumber',
        sortable: true,
      },
      {
        text: 'Return Result',
        value: 'returnResult',
        sortable: true,
      },
      {
        text: 'Rejection Reason',
        value: 'rejectionReason',
        sortable: true,
      },
      {
        text: 'Service Plan Number',
        value: 'servicePlanNo',
        sortable: false,
      },
      {
        text: 'Date Paid',
        value: 'datePaid',
        sortable: false,
      },
    ],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
      descending: true,
    },
  }),
  methods: {
    ...mapActions('orders/qantas', [
      'listFailedQantasPoints',
      'updateCompanyABN',
    ]),
    getFailedQantasPoints() {
      let vm = this;
      vm.listFailedQantasPoints()
        .then((data) => {
          vm.items = vm.formatItems(data);
          vm.total = data.length;
          vm.loading = false;
        })
        .catch((err) => {});
    },
    formatItems(items) {
      var formattedItems = [];
      for (var i = 0; i < items.length; i++) {
        //format Date
        items[i].datePaid = moment(String(items[i].datePaid)).format(
          'MM/DD/YYYY hh:mm'
        );
      }
      return items;
    },
    editItem(item) {
      let vm = this;
      vm.editedIndex = vm.items.indexOf(item);
      vm.editedItem = item;
      vm.updateABN = vm.editedItem != null ? vm.editedItem.abn : null;
      vm.dialog = true;
    },
    submit() {
      let vm = this;
      vm.editedItem.abn = vm.updateABN;
      vm.updateCompanyABN({
        custNo: vm.editedItem.custNo,
        abn: vm.updateABN,
        id: vm.editedItem.id,
      })
        .then((data) => {})
        .catch((err) => {});
      this.dialog = false;
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    vm.getFailedQantasPoints();
  },
};
</script>

<style scoped>
</style>